import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import OrderManagementApiService from 'Service/OrderManagement/OrderManagementApiService';
import { apiMethod, apiType, API_URL } from 'utils';
import { IPayload } from 'Model/IPayload';
import { GET_ACQUISITION_CODE_MAINTENANCE_EXCEL_DATA, GET_ACQUISITION_CODE_MAINTENANCE_GRID_DATA, GET_UPDATED_BY_ACQUISITION_LIST, SAVE_DISCOUNT_FLAG } from 'Store/Report/AcquisitionCodeMaintenance/AcquisitionCodeMaintenanceType';
import { setAcquisitionCodeMaintenanceExcelData, setAcquisitionCodeMaintenanceGridData, setDiscountFlag, setUpdatedByAcquisitionList } from 'Store/Report/AcquisitionCodeMaintenance/AcquisitionCodeMaintenanceAction';

function* getAcquisitionCodeMaintenanceGridData(payload:any): any {
    try {
        yield put(globalLoaderText("Fetching Data ...."));

        let payloadData: IPayload = {
            apiMethod: apiMethod.POST,
            apiType: apiType.OrderManagement,
            endpoint: `acquisition/grid`,
            payload: payload.payload
        }

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData

        );

        if (response) {
            yield put(setAcquisitionCodeMaintenanceGridData(response));
            yield put(globalLoaderText(""));
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setAcquisitionCodeMaintenanceGridData([]));
        yield put(globalLoaderText(""));
    }
}

function* getUpdatedByAcquisitionList(): any {
    try {
        yield put(globalLoaderText("Fetching Data ...."));

        let payloadData: IPayload = {
            apiMethod: apiMethod.GET,
            apiType: apiType.OrderManagement,
            endpoint: `acquisition/dropdown/updatedby`,
            payload: null
        }

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData

        );

        if (response) {
            yield put(setUpdatedByAcquisitionList(response));
            yield put(globalLoaderText(""));
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setUpdatedByAcquisitionList([]));
        yield put(globalLoaderText(""));
    }
}

function* saveDiscountFlag(payload:any): any {
    try {
        yield put(globalLoaderText("Fetching Data ...."));

        let payloadData: IPayload = {
            apiMethod: apiMethod.POST,
            apiType: apiType.OrderManagement,
            endpoint: `acquisition/update`,
            payload: payload.payload
        }

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData

        );

        if (response) {
            yield put(setDiscountFlag(response));
            yield put(globalLoaderText(""));
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setDiscountFlag(false));
        yield put(globalLoaderText(""));
    }
}


function* getAcquisitionCodeMaintenanceExcelData(payload:any): any {
    try {
        yield put(globalLoaderText("Fetching Data ...."));

        let payloadData: IPayload = {
            apiMethod: apiMethod.POST,
            apiType: apiType.OrderManagement,
            endpoint: `acquisition/excel`,
            payload: payload.payload
        }

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData

        );

        if (response) {
            yield put(setAcquisitionCodeMaintenanceExcelData(response));
            yield put(globalLoaderText(""));
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setAcquisitionCodeMaintenanceExcelData([]));
        yield put(globalLoaderText(""));
    }
}

function* watchAcquisitionCodeMaintenance() {
    yield takeEvery(GET_ACQUISITION_CODE_MAINTENANCE_GRID_DATA, getAcquisitionCodeMaintenanceGridData)
    yield takeEvery(GET_UPDATED_BY_ACQUISITION_LIST, getUpdatedByAcquisitionList)
    yield takeEvery(SAVE_DISCOUNT_FLAG, saveDiscountFlag)
    yield takeEvery(GET_ACQUISITION_CODE_MAINTENANCE_EXCEL_DATA, getAcquisitionCodeMaintenanceExcelData)

}

export default function* combinedSaga() {
    yield all([
        watchAcquisitionCodeMaintenance()
    ])
}
